'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { useAuth } from '@/lib/auth';

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const { user, loading, logout } = useAuth();
  const pathname = usePathname();
  const router = useRouter();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">加载中...</div>;
  }

  if (!user && pathname !== '/login') {
    router.replace('/login');
    return null;
  }

  // 防御:已登录但非 admin(例如 cookie 还存活但 tier 被降级)
  // login() 已挡了大部分情况,这里是兜底
  if (user && user.tier !== 'admin' && pathname !== '/login') {
    logout();
    return null;
  }

  if (pathname === '/login') return <>{children}</>;

  return (
    <>
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 h-12 flex items-center justify-between text-sm">
          <div className="flex items-center gap-6">
            <span className="font-bold text-blue-600">轻松说 后台</span>
            <Link href="/videos" className="text-gray-600 hover:text-blue-600">
              视频管理
            </Link>
            <Link href="/words" className="text-gray-600 hover:text-blue-600">
              全局词库
            </Link>
            <Link href="/invite-codes" className="text-gray-600 hover:text-blue-600">
              邀请码
            </Link>
            <Link href="/users" className="text-gray-600 hover:text-blue-600">
              账号管理
            </Link>
          </div>
          <div className="flex items-center gap-4">
            <Link href="/change-password" className="text-gray-500 hover:text-blue-600">
              {user?.email}
            </Link>
            <button onClick={logout} className="text-red-500 hover:text-red-600">
              退出
            </button>
          </div>
        </div>
      </nav>
      {children}
    </>
  );
}
